// extracted by mini-css-extract-plugin
export default {"tags":"FLLLDjU4","form":"bCP3DTZt","total":"AK6bM1jd"};